// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zcp-swatch-drag-area{height:100%;width:100%;user-select:none;border-radius:5px;position:relative}.zcp-swatch-bkgr{position:fixed;top:0;left:0;width:100%;height:100%;z-index:9999}", ""]);
// Exports
module.exports = exports;
